import { prisma } from "@/lib/db";
import { ArticleForm } from "../_form";

export const dynamic = "force-dynamic";

export default async function NewArticlePage() {
  const categories = await prisma.category.findMany({
    orderBy: { order: "asc" },
    select: { id: true, slug: true, name: true },
  });

  return (
    <div>
      <h1 className="font-display text-2xl lg:text-3xl font-bold mb-1">Tạo bài viết mới</h1>
      <p className="text-sm text-ink-muted mb-6">
        Soạn nháp, hẹn giờ, hoặc xuất bản ngay.
      </p>
      <ArticleForm mode="create" categories={categories} />
    </div>
  );
}
